<template>
  <Dialog
    :visible="shouldDeleteSizing"
    header="Confirm Deletion"
    :draggable="false"
    :style="{ width: '60vw' }"
    :closable="false"
    @hide="closeDialog"
    data-cy="delete-sizing-dialog"
  >
    <p data-cy="delete-confirm-text">Are you sure you want to delete this sizing?</p>
    <ul class="font-semibold" data-cy="sizing-title-list">
      <li>{{ sizingForm.initialData.value?.title }}</li>
    </ul>
    <p class="text-sm" data-cy="delete-scenario-text">These scenarios will be deleted:</p>
    <ul class="font-semibold" data-cy="scenario-list">
      <li v-for="s in scenarios" :key="s.id" :data-cy="'scenario-' + s.id">
        {{ s.title }}
      </li>
    </ul>

    <template #footer>
      <Button label="Cancel" class="p-button-text" @click="closeDialog" data-cy="cancel-button" />
      <Button
        autofocus
        label="Delete"
        class="p-button-danger"
        :disabled="isSubmitting"
        @click="handleDeleteSizing"
        data-cy="delete-button"
      />
    </template>
  </Dialog>
</template>


<script setup lang="ts">
import { haltUntilCompletion } from "@/composables/exchanges/mutationLimiter";
import { sizingFormKey } from "@/composables/scenarioDetailProvider/scenarioDetailProviderKeys";
import { injectStrict, omit } from "@/utils/utils";
import { computed, ref } from "vue";
import { useInsertSizingsRevisionMutation } from "gql/api";
import { useRouter } from "vue-router";
import { useMutationNotification } from "@/composables/logger/mutationNotification";

defineProps<{ shouldDeleteSizing: boolean }>();
const emit = defineEmits<{
  (e: "update:shouldDeleteSizing", value: boolean): void;
}>();

function closeDialog() {
  emit("update:shouldDeleteSizing", false);
}

const router = useRouter();
const { registerResultToast } = useMutationNotification();
const sizingForm = injectStrict(sizingFormKey);
const scenarios = computed(() => sizingForm.initialData.value?.scenarios);
const isSubmitting = ref(false);

const { executeMutation: insertSizingRevision } =
  useInsertSizingsRevisionMutation();

async function handleDeleteSizing() {
  if (isSubmitting.value) return;
  isSubmitting.value = true;

  sizingForm.reset();

  sizingForm.update({
    journal_deleted_at: "now()"
  });

  const ignoredSizingFields = [
    "parent_sizing",
    "author",
    "well",
    "customer",
    "scenarios"
  ];
  const sizingRevision = {
    ...omit(sizingForm.prepare(), (_, k) => ignoredSizingFields.includes(k))
  };

  const result = insertSizingRevision({ objects: [sizingRevision] });
  registerResultToast("Sizing Delete", result);

  await haltUntilCompletion();

  router.push({ name: "Sizings" });

  isSubmitting.value = false;
}
</script>
